 // @ts-nocheck 
import React from 'react'
import { Redirect, Route } from 'react-router'
import { isAuthenticatedHandle } from './utility';

export default function PrivateRoute({ children, ...rest }) {
 
    return (
      <Route
        {...rest}
        render={({ location }) =>
        isAuthenticatedHandle() 
        ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  }